// eslint-disable-next-line no-unused-vars
import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="Home-section">
          <div className="Home-hero">
          <div className="container Home-con">
            <div className="box box-div">
              <h1 className="mb-3">The Bedtime Story Generator</h1>
          
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <button className="log-btn" onClick={() => navigate("/signin")}>Login</button>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <button className="btn-1" onClick={() => navigate("/signup")}>Register</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
